import { useEffect, useState } from "react";
import { useSyntecContext } from "api/settings/syntec/SyntecProvider";
import { FormattedMessage } from "react-intl";
import { HandleModaleBO } from "components/bo/HandleModaleBO";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { TableManager } from "components/bo/admin-table/TableManager";
import { ACTIONS, ENTITIES, VAR_TYPES } from "constants/constants";
import { navigateView, navigateEdit, navigateToParent } from "utils/boHelper";
import Button from "core/buttons/button/Button";

export default function AdminSyntec({ action }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const {
    syntecByIdGetter,
    syntecCreate,
    syntecDeleteById,
    syntecList,
    syntecListGetter,
    syntecUpdateById,
    syntecPerId,
  } = useSyntecContext();

  const syntecForm = [
    {
      col: "name",
      id: "syntec-name",
      mandatory: true,
      editable: true,
      isMissingValue: null,
    },
    {
      col: "value",
      mandatory: true,
      id: "syntec-value",
      editable: true,
      isMissingValue: null,
      type: VAR_TYPES.NUMBER,
    },
    {
      col: "status",
      mandatory: true,
      id: "syntec-status",
      editable: true,
      isMissingValue: null,
      type: VAR_TYPES.DROPDOWN,
      choices: [
        { name: "Active", value: "Active" },
        { name: "Inactive", value: "Inactive" },
      ],
    },
  ];

  const [deleteData, setDeleteData] = useState(null);

  useEffect(() => {
    syntecListGetter();
  }, [syntecListGetter]);

  useEffect(() => {
    if (id) {
      syntecByIdGetter(id);
    }
  }, [id]);

  const handleDelete = async (syntecId) =>
    setDeleteData(syntecList.find((e) => e.id === syntecId));

  const validateDelete = async (syntecId) => {
    try {
      await syntecDeleteById(syntecId);
    } catch (error) {
      console.error(error);
    }
  };
  const handleCreate = (payload) => {
    try {
      syntecCreate(payload);
      navigateToParent(navigate, location);
    } catch (e) {
      console.error(e);
    }
  };
  const handleEdit = (payload) => {
    try {
      syntecUpdateById(payload.id, payload);
      navigateToParent(navigate, location);
    } catch (e) {
      console.error(e);
    }
  };

  // Todo gestion droits admin
  return (
    <div>
      {action === ACTIONS.LIST && (
        <div className="flex">
          <Button
            className="btn-hover-color"
            size="large"
            color="blue"
            id="new-syntec"
            onClick={() => navigateView("new", navigate, location)}
          >
            <FormattedMessage
              id={"admin_create_new"}
              defaultMessage={"Nouveau"}
            />
          </Button>
        </div>
      )}
      <br />
      <TableManager
        action={action}
        entity={ENTITIES.SYNTEC}
        entityPerId={syntecPerId}
        list={syntecList}
        inputs={syntecForm}
        navigateEdit={(propsId) => navigateEdit(propsId, navigate, location)}
        navigateView={(propsId) => navigateView(propsId, navigate, location)}
        handleCreate={handleCreate}
        handleDelete={handleDelete}
        handleEdit={handleEdit}
      />

      <div id="modalDelete">
        <HandleModaleBO
          setDeleteData={setDeleteData}
          validateDelete={validateDelete}
          deleteData={deleteData}
          entity={ENTITIES.SYNTEC}
        />
      </div>
    </div>
  );
}
